/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260108

*/

'use strict';

import {
    getAppToken,
    redirectToHomeURL,
    setMenu
} from './snSite.js';

const token = getAppToken();

const init = () => {
    if (!token) {
        window.location.href = "../Home/SignIn";
    }
    else if (token.IsAdmin === "True") {
        setMenu();
    }
    else if (token.GroupLeaderRights.length > 0) {
        redirectToHomeURL({ token: token });
    }
};

window.snHome = {
    init
};